import { render } from "./_StammdatenForm.vue?vue&type=template&id=6da419a9&ts=true"
import script from "./_StammdatenForm.vue?vue&type=script&lang=ts"
export * from "./_StammdatenForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\skillbase\\client\\node_modules\\.pnpm\\vue-loader@16.8.3_l4c6fk63aalreefgot6be7px2i\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__